import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-report-viewer-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule],
  templateUrl: './report-viewer-dialog.component.html',
  styleUrl: './report-viewer-dialog.component.scss',
})
export class ReportViewerDialogComponent implements OnChanges {
  @Input() visible = false;
  @Input() loading = false;
  @Input() title = '';
  @Input() isImage = false;
  @Input() imageUrl: string | null = null;
  @Input() documentUrl: SafeResourceUrl | null = null;
  @Input() rawUrl: string | null = null;
  @Input() errorMessage: string | null = null;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();
  @Output() retryLoad = new EventEmitter<void>();

  previewKey = 0;

  get fileIcon(): string {
    if (this.isImage) {
      return 'pi-image';
    }
    const name = (this.title || '').toLowerCase();
    if (name.endsWith('.pdf')) {
      return 'pi-file-pdf';
    }
    return 'pi-file';
  }

  get fileTypeLabel(): string {
    if (this.isImage) {
      return 'Image';
    }
    const name = (this.title || '').toLowerCase();
    if (name.endsWith('.pdf')) {
      return 'PDF';
    }
    const ext = (this.title || '').split('.').pop();
    return ext ? ext.toUpperCase() : 'File';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['documentUrl'] && this.documentUrl) || (changes['imageUrl'] && this.imageUrl)) {
      this.previewKey++;
    }
  }

  onVisibleChange(nextVisible: boolean): void {
    this.visibleChange.emit(nextVisible);
    if (!nextVisible) {
      this.closed.emit();
    }
  }

  openInNewTab(): void {
    const urlToOpen = this.rawUrl || this.imageUrl;
    if (!urlToOpen) {
      return;
    }

    window.open(urlToOpen, '_blank', 'noopener,noreferrer');
  }

  downloadFile(): void {
    const url = this.rawUrl || this.imageUrl;
    if (!url) {
      return;
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = this.title || 'document';
    link.rel = 'noopener noreferrer';
    link.click();
  }

  onRetry(): void {
    this.retryLoad.emit();
  }
}
